import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DisplayableItemListComponent } from '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component';
import { DigitalSpotlightTemplatesViewModel } from '../digital-spotlight-templates-view-model';

@Component({
  selector: 'app-digital-spotlight-template-list',
  templateUrl:
    '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component.html',
  styleUrls: [
    '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component.scss',
    './digital-spotlight-template-list.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DigitalSpotlightTemplateListComponent extends DisplayableItemListComponent {
  constructor(
    digitalSpotlightTemplatesViewModel: DigitalSpotlightTemplatesViewModel // Provided by parent component
  ) {
    super(digitalSpotlightTemplatesViewModel);
  }
}
